/**
 * Gravity Variant Manager clones each product card once per variant.
 * Keep one card per product handle in collection/search grids.
 */
(() => {
  const CARD_SELECTOR = "pdp-related-card, product-card";
  const LIST_SELECTOR = "product-list, .product-list";
  let collapsing = false;
  let scheduled = 0;

  const collapseDuplicateCards = () => {
    if (collapsing) {
      return;
    }

    collapsing = true;

    try {
      const lists = document.querySelectorAll(LIST_SELECTOR);
      const scopes = lists.length ? Array.from(lists) : [document];

      scopes.forEach((scope) => {
        const seen = new Set();

        scope.querySelectorAll(CARD_SELECTOR).forEach((card) => {
          const key = (
            card.getAttribute("data-product-handle") ||
            card.getAttribute("handle") ||
            ""
          ).trim();

          if (!key) {
            return;
          }

          if (seen.has(key)) {
            card.remove();
            return;
          }

          seen.add(key);
        });
      });
    } finally {
      collapsing = false;
    }
  };

  const scheduleCollapse = () => {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(collapseDuplicateCards, 50);
  };

  const start = () => {
    collapseDuplicateCards();
    scheduleCollapse();

    const observer = new MutationObserver(scheduleCollapse);
    const observe = () => {
      document.querySelectorAll(LIST_SELECTOR).forEach((list) => {
        observer.observe(list, { childList: true, subtree: true });
      });
    };

    observe();
    observer.observe(document.body, { childList: true, subtree: false });

    window.addEventListener("load", () => {
      collapseDuplicateCards();
      window.setTimeout(collapseDuplicateCards, 400);
      window.setTimeout(collapseDuplicateCards, 1200);
      observe();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
